import React from 'react';
import Link from 'next/link';
import Layout1x1 from 'components/Layout1x1';
import NextSteps from 'components/NextSteps';
import SalesCalloutHTO from 'components/SalesCalloutHTO';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import { withPageStaticProps } from 'utils/header';

class TermsAndConditions extends React.Component {
  render() {
    return (
      <>
        <Layout1x1 className="m-section-hero">
          <h1 className="text-h2-display">Terms of Service</h1>

          <h2 className="text-h4 text-gray-dark">Revised: July 15, 2015</h2>

          <p>
            Your information privacy is extremely important to us. These Terms of Service (“Terms”) govern your use of the Menguin website
            and the Menguin mobile application (“Site”) and the Menguin products and services (“Services”). These Terms apply to all users
            of the Site and Services. The Site and Services are provided by Menguin, Inc. and its wholly owned subsidiaries (collectively
            “Menguin” “we” “our” “us”).
          </p>

          <p>By using the Site or Services, you are agreeing to these Terms. Please read them carefully.</p>

          <ol className="space-y-32">
            <li className="space-y-16">
              <p>
                <strong>Eligibility</strong>
              </p>
              <p>
                You must be at least 13 years old to use the Site or the Services. If you are under the age of majority in your state of
                residence, a minor, your parent or legal guardian must agree to these Terms on your behalf and you may only access and use
                the Site and Services with permission from your parent or legal guardian.{' '}
              </p>
            </li>

            <li className="space-y-16">
              <p>
                <strong>Additional Terms</strong>
              </p>
              <p>
                Some of our Services have additional terms and conditions (“Additional Terms”). Where Additional Terms apply to a Service,
                we will make them available to you when you use of that Service. By using such Services, you are agreeing to the applicable
                Additional Terms.
              </p>

              <li className="space-y-16">
                <p>
                  <strong>Acceptable Use of the Site and Services</strong>
                </p>
                <p>
                  You are responsible for your use of the Site and Services, and for any use of the Site or Services made using your
                  account. When you use the Site or Services, you shall not:
                </p>

                <ul>
                  <li className="space-y-16">violate any law or regulation;</li>

                  <li className="space-y-16">
                    violate or infringe other people’s intellectual property, privacy, publicity, or other legal rights;
                  </li>

                  <li className="space-y-16">
                    use our Site or Services to transmit, distribute, post, or submit any information concerning any other person or entity,
                    including photographs or personal contact information of others, without their permission;
                  </li>

                  <li className="space-y-16">
                    transmit anything that is illegal, abusive, harassing, harmful to reputation, pornographic, indecent, profane, obscene,
                    hateful, racist, or otherwise objectionable;
                  </li>

                  <li className="space-y-16">send unsolicited or unauthorized advertising or commercial communications, such as spam;</li>

                  <li className="space-y-16">transmit any malicious code or computer viruses;</li>

                  <li className="space-y-16">stalk, harass, or harm another individual;</li>

                  <li className="space-y-16">impersonate or misrepresent your affiliation with someone else; </li>

                  <li className="space-y-16">
                    use any means to “scrape,” “crawl,” or “spider” any web pages contained in the Site (although Menguin may allow
                    operators of public search engines to use spiders to index materials from the Site for the sole purpose of creating
                    publicly available searchable indices of the materials, but not caches or archives of such materials, and Menguin
                    reserves the right to revoke these exceptions either generally or in specific cases);{' '}
                  </li>

                  <li className="space-y-16">
                    use automated methods to use the Site or Services in a manner that sends more requests to the Menguin servers in a given
                    period of time than a human can reasonably produce in the same period by using a conventional web browser;{' '}
                  </li>

                  <li className="space-y-16">
                    interfere with or damage the Site or Services, including, through the use of viruses, cancel bots, Trojan horses,
                    malicious code, flood pings, denial-of-service attacks, packet or IP spoofing, forged routing or electronic mail address
                    information, or similar methods or technology;
                  </li>

                  <li className="space-y-16">
                    register for more than one Menguin account or register for a Menguin account on behalf of an individual other than
                    yourself;
                  </li>

                  <li className="space-y-16">
                    recruit or otherwise solicit any user to join third party services or websites that are competitive to Menguin, without
                    Menguin’s prior written approval;
                  </li>

                  <li className="space-y-16">
                    use, display, mirror, or frame the Site or any individual element within the Site or Services, Menguin’s name, any
                    Menguin trademark, logo, or other proprietary information, or the layout and design of any page or form contained on a
                    page, without Menguin’s express written consent;
                  </li>

                  <li className="space-y-16">
                    access, tamper with, or use non-public areas of the Site, Menguin’s computer systems, or the technical delivery systems
                    of Menguin’s providers;
                  </li>

                  <li className="space-y-16">
                    attempt to probe, scan, or test the vulnerability of any Menguin system or network or breach any security or
                    authentication measures;
                  </li>

                  <li className="space-y-16">
                    avoid, bypass, remove, deactivate, impair, descramble, or otherwise circumvent any technological measure implemented by
                    Menguin or any of Menguin’s providers or any other third party (including another user) to protect the Site or Services;
                  </li>

                  <li className="space-y-16">
                    attempt to decipher, decompile, disassemble, or reverse engineer any of the software used to provide the Site or
                    Services; or
                  </li>

                  <li className="space-y-16">advocate, encourage, or assist any third party in doing any of the foregoing.</li>
                </ul>

                <p>
                  Menguin will investigate and prosecute violations of any of the above to the fullest extent of the law. Menguin may
                  involve and cooperate with law enforcement authorities in prosecuting users who violate these Terms. You acknowledge that
                  Menguin has no obligation to monitor your access to or use of the Site or Services or to review or edit any User Content,
                  but has the right to do so for the purpose of operating the Site or Services, to ensure your compliance with these Terms,
                  or to comply with applicable law or the order or requirement of a court, administrative agency, or other governmental
                  body. Menguin reserves the right, at any time and without prior notice, to remove or disable access to any content on the
                  Site that Menguin, at its sole discretion, considers to be objectionable for any reason, in violation of these Terms, or
                  otherwise harmful to the Site or Services.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>User Content</strong>
                </p>
                <p>
                  You own all content and information you post or share using the Site or Services (referred to as “User Content”). You give
                  Menguin permission to use your User Content as follows: you grant to Menguin and its affiliates a license to use, copy, or
                  display your User Content in connection with the Site or Services. We may display advertisements in connection with your
                  User Content or on pages where your User Content may be viewed by you or others and we may use your User Content to
                  advertise and promote Menguin, the Site, or the Services. Our license to your User Content is non-exclusive, meaning you
                  may use the User Content for your own purposes or let others use your User Content for their purposes. Our license to your
                  User Content is fully-paid and royalty free, meaning we do not owe you anything else in connection with our use of your
                  User Content. We may exercise our rights anywhere in the world. Finally, our license is perpetual, meaning that our
                  license lasts for an indefinite period of time.{' '}
                </p>

                <ul>
                  <li className="space-y-16">
                    you own all rights to your User Content or, alternatively, that you have the right to give Menguin the rights described
                    above;
                  </li>

                  <li className="space-y-16">
                    you have paid and will pay in full any fees or other payments that may be related to the use of your User Content; and
                  </li>

                  <li className="space-y-16">
                    your User Content does not infringe the intellectual property rights, privacy rights, publicity rights, or other legal
                    rights of any third party.
                  </li>
                </ul>

                <p>
                  We may refuse to accept or transmit any User Content. We may remove User Content from the Site or Services for any reason.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Ownership</strong>
                </p>
                <p>
                  Other than User Content, we own or license the content on the Site and Services, including software, text, visual, and
                  audio content (collectively, the “Content”) and Menguin’s trademarks, logos, and brand elements (collectively, the
                  “Marks”). The Content and Marks are protected under U.S. and international laws. We reserve all rights not expressly
                  granted to you.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Copyright and Intellectual Property Policy</strong>
                </p>

                <h3 className="text-h4">Notice of Copyright or Intellectual Property Infringement</h3>

                <p>
                  We respect the intellectual property rights of others. Please notify us in writing, by e-mail or mail to our designated
                  agent listed below, if you believe that a user of the Site or Services has infringed your intellectual property rights. We
                  provide this policy pursuant to Section 512 of the Copyright Revision Act, as enacted through the Digital Millennium
                  Copyright Act (“DMCA”).
                </p>

                <ul>
                  <li className="space-y-16">
                    identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works are covered by
                    a single notification, a representative list of such works;
                  </li>

                  <li className="space-y-16">
                    identification of the claimed infringing material and information reasonably sufficient to permit Menguin to locate the
                    material on the Site or Services;{' '}
                  </li>

                  <li className="space-y-16">
                    information reasonably sufficient to permit us to contact you, such as an address, telephone number, and, if available,
                    an e-mail address;
                  </li>

                  <li className="space-y-16">
                    a statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its
                    agent, or the law;
                  </li>

                  <li className="space-y-16">
                    a statement by you, made under penalty of perjury, that the above information in your notification is accurate and that
                    you are the copyright owner or authorized to act on the copyright owner’s behalf; and{' '}
                  </li>

                  <li className="space-y-16">your physical or electronic signature. </li>
                </ul>

                <p>
                  You acknowledge and agree that upon receipt and notice of a claim of infringement, we may immediately remove the
                  identified materials from the Site and Services without liability.
                </p>

                <h3 className="text-h4">Counter-Notice by Accused User</h3>

                <p>
                  If we have taken down your materials due to suspicion of copyright infringement, you may dispute the alleged infringement
                  by sending a written communication by e-mail or mail to our designated agent below. That written communication should
                  include the following:
                </p>

                <ul>
                  <li className="space-y-16">your physical or electronic signature;</li>

                  <li className="space-y-16">
                    identification of the material that has been removed or to which access has been disabled and the location at which the
                    material appeared before it was removed or access to it was disabled;{' '}
                  </li>

                  <li className="space-y-16">
                    a statement under penalty of perjury that you have a good faith belief that the material was removed or disabled as a
                    result of mistake or misidentification of the material to be removed or disabled; and
                  </li>

                  <li className="space-y-16">
                    your name, address, and telephone number, and a statement that you consent to the jurisdiction of Federal District Court
                    for the judicial district in which such address is located, or if your address is outside of the United States, the
                    United States District Court for the Northern District of California, and that you will accept service of process from
                    the person who provided notification of copyright infringement or an agent of such person.
                  </li>
                </ul>

                <p>
                  Please send all notices under the above copyright infringement policies by e-mail or mail to the following individual,
                  designated as Menguin’s agent for receipt of notifications of claimed infringement:{' '}
                </p>

                <address>
                  <p>
                    <strong>KC Maxwell</strong>
                  </p>{' '}
                  <br />
                  235 Montgomery Street, Suite 1070, San Francisco, CA 94104
                  <br />
                  <a href="mailto:kcm@kcmaxlaw.com">kcm@kcmaxlaw.com</a>
                </address>

                <p>
                  Please do not send notices or inquiries about anything other than alleged copyright infringement to our Agent for
                  Notice.{' '}
                </p>

                <h3 className="text-h4">Repeat Infringers</h3>

                <p>
                  Your account will be terminated if, in our discretion, you are determined to be a repeat infringer. Repeat infringers are
                  users who have been the subject of more than one valid takedown request that has not been successfully rebutted.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Privacy</strong>
                </p>
                <p>
                  Menguin respects your privacy. Please read our <Link href="/support/privacy-policy">Privacy Policy</Link> to learn how we
                  collect, use, and disclose information about you.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Third Party Content and Interactions</strong>
                </p>
                <p>
                  The Site and Services may contain features and functionalities that may link you or provide you with access to third party
                  content which is completely independent of Menguin, including websites, directories, servers, networks, systems,
                  information and databases, applications, software, programs, products or services, and the Internet in general. Your
                  interactions with organizations or individuals found on or through the Site and Services are solely between you and such
                  organizations or individuals. You should make whatever investigation you feel necessary or appropriate before proceeding
                  with any interaction with any of these third parties. You agree that Menguin is not responsible or liable for any loss or
                  damage of any kind or nature incurred as the result of any such dealings. If there is a dispute between users of the Site
                  or Services, or between users and any third party, you understand and agree that Menguin is under no obligation to become
                  involved. In the event that you have a dispute with any other user of the Site or Services, you hereby release Menguin and
                  its affiliates, and their officers, employees, agents, and successors from claims, demands, and damages (actual and
                  consequential) of every kind or nature, known and unknown, suspected and unsuspected, disclosed and undisclosed, arising
                  out of or in any way related to such disputes or the Site and Services. IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE
                  CALIFORNIA CIVIL CODE SECTION 1542, WHICH PROVIDES: A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES
                  NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH, IF KNOWN BY HIM MUST HAVE
                  MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Returns and Payment</strong>
                </p>
                <p>
                  <p>
                    <strong>All items for sale on the Site are final sale. No returns are accepted, except for defective items.</strong>
                  </p>{' '}
                  Please see our Rental Terms below for information about fees and payments for rental items. Except where noted otherwise,
                  the prices displayed for the Services do not include any applicable sales tax that we may be required to collect from
                  you.{' '}
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Rentals</strong>
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Product and Service Images and Descriptions</strong>
                </p>
                <p>
                  We attempt to be as accurate as possible. However, we do not warrant that product or service images or descriptions or
                  other content displayed on the Site or Service is accurate, complete, reliable, current, or error-free.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Links</strong>
                </p>
                <p>
                  The Site and Services may contain links to other websites. A link to a third party’s website does not mean that we endorse
                  it or that we are affiliated with it. We are not responsible or liable for any damage or loss related to the use of any
                  third-party website. You should always read the terms and conditions and privacy policy of a third-party website before
                  using it.{' '}
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Changes to the Site or Services</strong>
                </p>
                <p>
                  Menguin enhances and updates the Site and Services often. We may change or discontinue the Site or any Services at any
                  time, with or without further notice to you.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Termination</strong>
                </p>
                <p>
                  We reserve the right not to provide the Site or Services to any user. We also reserve the right to terminate any user’s
                  right to access the Site or Services at any time, in our discretion. If you violate any of these Terms, your permission to
                  use the Site and Services automatically terminates.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Disclaimer and Limitations on Our Liability</strong>
                </p>
                <p>
                  YOU USE THE SITE AND SERVICES AT YOUR OWN RISK. THE SITE AND SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS.
                  TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, Menguin AND ITS OFFICERS, EMPLOYEES, DIRECTORS, SHAREHOLDERS, PARENTS,
                  SUBSIDIARIES, AFFILIATES, AGENTS, AND LICENSORS (REFERRED TO COLLECTIVELY AS “AFFILIATES”) DISCLAIM ALL WARRANTIES OF ANY
                  KIND, EXPRESS OR IMPLIED, WITH RESPECT TO THE SITE AND SERVICES (INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY,
                  FITNESS FOR A PARTICULAR USE OR PURPOSE, AND NON-INFRINGEMENT).{' '}
                </p>

                <p>
                  IN PARTICULAR, Menguin AND ITS AFFILIATES MAKE NO REPRESENTATIONS OR WARRANTIES ABOUT THE ACCURACY OR COMPLETENESS OF
                  CONTENT AVAILABLE ON OR THROUGH THE SITE OR SERVICES (INCLUDING ANY RECOMMENDATIONS OR OTHER CONTENT AVAILABLE ON OR
                  THROUGH THE SITE OR SERVICES), OR THE CONTENT OF ANY WEBSITES OR RESOURCES LINKED TO THE SITE OR SERVICES. Menguin AND ITS
                  AFFILIATES WILL HAVE NO LIABILITY FOR ANY: (a) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT; (b) PERSONAL INJURY OR
                  PROPERTY DAMAGE RESULTING FROM YOUR ACCESS TO OR USE OF THE SITE OR SERVICES; (c) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
                  SERVERS OR OF ANY PERSONAL OR FINANCIAL INFORMATION; (d) ANY INTERRUPTION OF TRANSMISSION TO OR FROM THE SITE OR SERVICES;
                  (e) ANY COMPUTER VIRUSES OR MALICIOUS CODE THAT MAY BE TRANSMITTED ON OR THROUGH THE SITE OR SERVICES; OR (f) ANY LOSS OR
                  DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY FUNCTIONALITY OR CONTENT POSTED, E-MAILED, TRANSMITTED, OR
                  OTHERWISE MADE AVAILABLE ON OR THROUGH THE SITE OR SERVICES.{' '}
                </p>

                <p>
                  Menguin AND ITS AFFILIATES DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY THIRD PARTY PRODUCT OR
                  SERVICE RECOMMENDED, ADVERTISED, OR OFFERED ON OR THROUGH THE SITE OR SERVICES OR ANY LINKED WEBSITE.{' '}
                </p>

                <p>
                  YOU UNDERSTAND AND AGREE THAT ANY MATERIAL OR INFORMATION DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SITE OR
                  SERVICES IS DONE AT YOUR OWN RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE ARISING FROM DOING SO. NO ADVICE
                  OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM Menguin OR THROUGH THE SITE OR SERVICES WILL CREATE ANY
                  WARRANTY NOT EXPRESSLY MADE IN THESE TERMS.
                </p>

                <p>
                  TO THE EXTENT PERMITTED BY LAW, NEITHER Menguin NOR ITS AFFILIATES WILL BE LIABLE UNDER ANY THEORY OF LIABILITY FOR ANY
                  INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES, INCLUDING, DAMAGES FOR LOSS OF REVENUES,
                  PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES (EVEN IF SUCH PARTIES WERE ADVISED OF, KNEW OF, OR SHOULD HAVE
                  KNOWN OF THE POSSIBILITY OF SUCH DAMAGES), ARISING FROM OR RELATING TO THE SITE OR SERVICES OR THESE TERMS.{' '}
                </p>

                <p>
                  TO THE EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF Menguin AND ITS AFFILIATES FOR ANY CLAIMS UNDER THESE TERMS IS
                  LIMITED TO THE AMOUNT YOU PAID US TO USE THE SERVICES GIVING RISE TO SUCH CLAIMS.
                </p>

                <p>
                  Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for
                  incidental or consequential damages. Accordingly, some of the above limitations and disclaimers may not apply to you. To
                  the extent Menguin may not, as a matter of applicable law, disclaim any implied warranty or limit its liabilities, the
                  scope and duration of such warranty and the extent of Menguin’s liability will be the minimum permitted under such law.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Indemnification</strong>
                </p>
                <p>
                  You agree to indemnify, defend, and hold Menguin and its Affiliates harmless from and against any and all claims,
                  liabilities, damages, losses, costs, expenses, and fees of any kind (including reasonable attorneys’ fees and legal
                  costs), arising from or relating to: (a) any information (including your User Content or any other content) that you or
                  anyone using your account submit, post, or transmit on or through the Site or Services; (b) the use of the Site or
                  Services by you or anyone using your account; (c) the violation of these Terms by you or anyone using your account; or (d)
                  the violation of any rights of any third party, including intellectual property, privacy, publicity, or other proprietary
                  rights by you or anyone using your account. Menguin reserves the right, at its own expense, to assume the exclusive
                  defense and control of any matter otherwise subject to indemnification by you. If we do assume the defense of such a
                  matter, you will reasonably cooperate with Menguin in such defense.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Other Provisions</strong>
                </p>
                <p>
                  Under no circumstances will Menguin be held liable for any delay or failure in performance due in whole or in part to any
                  acts of nature or other causes beyond its reasonable control.
                </p>

                <p>
                  These Terms will be governed by and construed in accordance with the laws of the State of California, without giving
                  effect to any conflict of laws rules or provisions.{' '}
                </p>

                <p>
                  You agree that any action of whatever nature arising from or relating to these Terms, the Site, or any Services will be
                  filed only in the state or federal courts located in San Francisco County, California. You consent and submit to the
                  personal jurisdiction of such courts for the purposes of any such action.
                </p>

                <p>
                  If any provision of these Terms is found to be unlawful, void, or unenforceable, then that provision will be deemed
                  severable from these Terms and will not affect the validity or enforceability of any remaining provisions.
                </p>

                <p>
                  The failure of Menguin to enforce any right or provision of these Terms will not prevent Menguin from enforcing such right
                  or provision in the future.
                </p>

                <p>
                  You may not assign these Terms to anyone without our prior written consent. However, you agree that we may assign these
                  Terms to an Affiliate or in connection with a merger, acquisition, a sale of assets, or by operation of law, without your
                  consent.
                </p>
              </li>

              <li className="space-y-16">
                <p>
                  <strong>Changes to these Terms</strong>
                </p>
                <p>
                  We may change these Terms from time to time. If we change these Terms, we will inform you by posting the revised Terms on
                  the Site. Those changes will go into effect on the “Revised” date shown in the revised Terms. By continuing to use the
                  Site or Services, you are agreeing to the revised Terms.
                </p>
              </li>
            </li>
          </ol>

          <hr className="border-gray" />

          <h2 id="rental-terms" className="text-h2-display">
            Rental Terms
          </h2>

          <h2 className="text-h4 text-gray-dark">Revised: March 24, 2020</h2>

          <p>
            These Rental Terms govern your rentals from Menguin, Inc. (“Menguin” “we” “our” “us”). By renting from us, you are agreeing to
            these Rental Terms. Please read them carefully.
          </p>

          <h3 className="text-h4">Placing Your Rental Order</h3>

          <p>
            You can rent an item on your own or as part of an event. If you rent an item on your own, you will still need to create an event
            for your rental. You must create an account to place an order or to create an event. If you are renting as part of an event, the
            event creator will pre-select all items to be rented and you will receive an e-mail invitation to place your order. To complete
            your order, you must provide your sizing and measurement information and any other information, such as event date and payment
            information, as requested by Menguin. If you are renting items pre-selected by an event creator, you may not delete or change
            any items in the order, but you may order additional items.{' '}
          </p>

          <p>
            To complete your order, you must enter your measurements. You can either measure with a friend using a tailor’s tape (we’ll send
            you one for free) and our simple tutorial videos. Valid only for customers who have arrived at this page from an invitation from
            Menguin. Non-transferrable. Offer valid while supplies last. We reserve the right to refuse fulfillment on complimentary tape
            measure requests that we believe are not from a Menguin invitation.
          </p>

          <p>
            Orders completed less than 16 days (21 days for AK, HI) prior to an event will be subject to rush shipping and processing. You
            must complete your order—including providing your measurements and payment—before the 16th day (21st day for HI and AK) deadline
            in order to avoid the rush shipping and processing. If you need to make any changes to your order within 16 days of your event,
            please do so by contacting the Concierge Services group as the event will be closed to changes online.
          </p>

          <h3 className="text-h4">Payment</h3>

          <p>
            Payment for all rentals is due in full upon placing an order. Payment in full is required to finalize an order.{' '}
            <p>
              <strong>
                By submitting your payment information to us, you authorize Menguin to charge your payment card, or other payment method
                associated with your account, for all rental fees and any other fees incurred as described in these Rental Terms or at the
                time of placing your order within a reasonable time after placing your order.{' '}
              </strong>
            </p>{' '}
            When the event creator creates a new event, he or she will select to pay for the rentals or for the participants to pay. Unless
            the event creator selects the option to pay for your rental items, you are responsible for making all payments.
          </p>

          <h3 className="text-h4">Receiving Your Rental Items</h3>

          <p>
            All rental items will be received by you about 14 days before your event date. You should try on your items as soon as you
            receive them. If any item does not fit, please contact us within 48 hours of package receipt. If you contact us 48 hours after
            receipt and we need to re-ship items, a rush shipping charge may apply.
          </p>

          <p>
            Subject to availability, we may send you a different size to arrive prior to your event date or otherwise help you resolve any
            issues with your items in our discretion.
          </p>

          <h3 className="text-h4">Returning Your Rental Items</h3>

          <p>
            After your event, use the bag your items arrived in and the pre-paid shipping label supplied with your order to package your
            items. Drop off at UPS or the U.S. Postal Service or arrange for a pick from UPS. You must deposit your returned rental with the
            shipper no later than 3 days after the event date you or the event creator supplied to Menguin. Returned items dated any later
            will be subject to a late fee. Any items that are returned damaged or that are not returned to Menguin within 21 days of your
            event date (without making arrangements for a later return and paying any additional applicable fees) will be subject to the
            applicable replacement and processing fees. You will not receive any refund or other payment after returning your items. You do
            not need to clean your items prior to returning them.
          </p>

          <h3 className="text-h4">Fees</h3>

          <p>
            In addition to the cost of your rental, the following fees may also apply as detailed in these Rental Terms. In the event you
            incur any additional fees, your payment card or account will automatically be charged. Menguin reserves the right to change any
            of these fees at any time without further notice.
          </p>

          <table>
            <tbody>
              <tr>
                <td className="border-1 border-gray p-8">Late Fee Per person, per day</td>

                <td className="border-1 border-gray p-8">$25</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Rush Shipping and Processing</td>

                <td className="space-y-16 border-1 border-gray p-8">
                  <h4 className="text-h5">If a new order:</h4>

                  <ul className="space-y-8">
                    <li className="space-y-16">$50.00 if less than 16 days from event date</li>

                    <li className="space-y-16">$100.00 if less than 7 days from event date</li>
                  </ul>

                  <h4 className="text-h5">If a reshipment:</h4>

                  <ul className="space-y-8">
                    <li className="space-y-16">$50.00 if greater than 48 hours after delivery</li>

                    <li className="space-y-16">$100.00 if less than 72 hours from the event date</li>
                  </ul>

                  <p>$125.00 if Saturday delivery</p>
                </td>
              </tr>
            </tbody>
          </table>

          <h3 className="text-h4">Replacement and Processing Fees:</h3>

          <table className="w-full">
            <tbody>
              <tr>
                <td className="border-1 border-gray p-8">Jacket</td>

                <td className="border-1 border-gray p-8">$600.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Pants</td>

                <td className="border-1 border-gray p-8">$200.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Vest</td>

                <td className="border-1 border-gray p-8">$150.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Shirt</td>

                <td className="border-1 border-gray p-8">$100.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Tie</td>

                <td className="border-1 border-gray p-8">$100.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Cummerbund</td>

                <td className="border-1 border-gray p-8">$100.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Shoes</td>

                <td className="border-1 border-gray p-8">$200.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Belt</td>

                <td className="border-1 border-gray p-8">$100.00</td>
              </tr>

              <tr>
                <td className="border-1 border-gray p-8">Accessories (e.g., Studs, Cufflinks)</td>

                <td className="border-1 border-gray p-8">$50.00</td>
              </tr>
            </tbody>
          </table>

          <h3 className="text-h4">Cancelling or Changing Your Order</h3>

          <p>
            You may cancel your order and receive a full refund of the rental fee up to 3 weeks (21 days) prior to your event date. Any
            other changes to your order (subject to availability) must also be received at least 3 weeks (21 days) prior to your event date.
            If your order has shipped, a credit will be issued if the unused garments are returned to UPS prior to the event date. If you
            need to make any changes to your order within 3 weeks (21 days) of your event date, please do so by contacting us as the event
            will be closed to changes online. Please note, if you have not cancelled your order within 3 weeks (21 days) of your event date
            there will be a $40 shipping and restocking fee.
          </p>

          <h3 className="text-h4">Changes to this Rental Terms</h3>

          <p>
            We may change these Rental Terms from time to time. If we change these Rental Terms, we will inform you by posting the revised
            Rental Terms on the Menguin website (“Site”). Those changes will go into effect on the “Revised” date shown in the revised
            Rental Terms. By continuing to use the Site or entering into a rental transaction with us, you are agreeing to the revised
            Rental Terms.
          </p>
        </Layout1x1>
        <NextSteps
          ctaPageName="terms_and_conditions"
          salesCallout1={<SalesCalloutHTO ctaPageName="terms_and_conditions" />}
          salesCallout2={<SalesCalloutSwatches ctaPageName="terms_and_conditions" />}
        />
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default TermsAndConditions;
